import Editor from "@monaco-editor/react";
import { Card } from "antd";
import PropTypes from "prop-types";

const TranslationEditor = ({
  height = "50vh",
  translations,
  onUpdate,
  loading = false,
}) => {
  return (
    <Card loading={loading}>
      <Editor
        height={height}
        defaultLanguage="json"
        onChange={onUpdate}
        defaultValue={JSON.stringify(translations, null, 2)}
      />
    </Card>
  );
};

TranslationEditor.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  translations: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
  onUpdate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default TranslationEditor;
